import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import ResponsiveAppBar from "../component/Header";
import Footer from "../component/Footer";

export default function NotFound() {
  const [loading, setLoading] = useState(true);
  setTimeout(() => setLoading(false), 2000);

  if (loading) {
    return (
      <>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    );
  }
  return (
    <>
      <Box
        // sx={{ textAlign: "center", my: 4, height: "calc(100vh - 168px)" }}
        className="error-msg-div"
        sx={{ color: "white" }}
      >
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </Box>
    </>
  );
}
